function injectJS(path: string, cb?: (this: GlobalEventHandlers, ev: Event) => any) {
	// Inject a script tag with the path given. Once the script is loaded, it executes the callback.
	const script = document.createElement("script");
	if (!!cb) {
		script.onload = cb;
	}
	script.type = "text/javascript";
	script.async = true;
	script.src = path;
	const head = document.getElementsByTagName("head")[0];
	const firstScript = head.getElementsByTagName("script")[0];
	head.insertBefore(script, firstScript);
}

/**
 * Simple object to handle the loading and registration of storage adapters.
 *
 * @export
 * @class AdapterReceiver
 */
export default class AdapterReceiver {
	// Callbacks
	private callbacks: Record<string, Function> = {};

	// The "adapter" and "storageAdapter" are roughly the same
	public adapters: Record<string, any> = {};

	// The "adapter" and "storageAdapter" are roughly the same; "storageAdapter" exists for backward compatability
	public storageAdapters: Record<string, any> = {};

	constructor() {
		this.callbacks = {};
		this.adapters = {};
		this.storageAdapters = {};
		this.loadModel = this.loadModel.bind(this);
		this.loaded = this.loaded.bind(this);
		return this;
	}

	/**
	 * Loads the model into the page and caches the callback.
	 */
	loadModel(name: string, path: string, cb: (this: GlobalEventHandlers, ev: Event) => any) {
		// 2nd param is a callback that fires onLoad. We found that this event was unreliable, so we created the AdapterReceiver.
		this.callbacks[name] = cb;
		injectJS(path);
	}

	/**
	 * When the baseStorageModel is loaded, it will call `loaded` on `global.adapterReceiver`. This method will let async know that the file has been successfully loaded.
	 */
	loaded(name: string, adapter: any) {
		// BaseStorage and LogAdapter are the only two places where AdapterReceiver.loaded() is called; "adapter" may be an instance of either one of those
		this.adapters[name] = adapter;
		// old variable. leaving for backwards compatibility.
		this.storageAdapters[name] = adapter;
		if (this.callbacks[name]) {
			this.callbacks[name]();
			delete this.callbacks[name];
		} else {
			console.info("`.loaded` invoked on Adapter Receiver by a storage adapter not loaded dynamically", name);
		}
	}
}
